// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3fOUd","log":"ModalInventoryLogs_log__xUOpB","date":"ModalInventoryLogs_date__2rKNK","userName":"ModalInventoryLogs_userName__2P8cJ"};